import React, { createContext, useContext, useState } from 'react';

// Create a new context
export const CaptchaContext = createContext();

// Create a context provider component
export const CaptchaContextProvider = ({ children }) => {
	const [buttonDisabled, setButtonDisabled] = useState(true);

  return (
    <CaptchaContext.Provider value={{ buttonDisabled, setButtonDisabled }}>
      {children}
    </CaptchaContext.Provider>
  );
};

// Custom hook to use the context
export const useCaptchaContext = () => {
  return useContext(CaptchaContext);
};